import React from "react";
import { bool } from "prop-types";

import LoginUser from "./LoginUser";

const OnboardingPage = ({ isDesktop, isMobile }) => {
    const isBackoffice = window.self !== window.top;

    return <>{!isBackoffice && <LoginUser isDesktop={isDesktop} isMobile={isMobile} />}</>;
};

OnboardingPage.propTypes = {
    isDesktop: bool.isRequired,
    isMobile: bool.isRequired,
};

export default OnboardingPage;
